import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b145f1a4"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b145f1a4')) {
      api.createRecord('b145f1a4', component.options)
    } else {
      api.reload('b145f1a4', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b145f1a4", function () {
      api.rerender('b145f1a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/index/index.vue"
export default component.exports